import { AssetContext } from '@pages/Asset/Asset.query';
import { format } from 'date-fns';
import { useContext } from 'react';
import UserPlaceholder from '@assets/svg/avatar-placeholder.svg';

import { IAssetLog } from '@models/AssetLog.model';
import { useSelector } from 'react-redux';
import { checkDevice } from '@store/redux/features/mobile/mobileSelectors';
import {
  Column,
  Content,
  ContentGroup,
  DateContent,
  EndOfHistory,
  EventNameContent,
  TriggeredByContent,
  TriggeredByGroup,
  TriggeredByPicture,
  TriggeredByText,
  ValueRow,
} from '../../AssetHistory.styles';
import { AssetHistoryValues } from '../AssetHistoryValues/AssetHistoryValues';

const AssetHistoryContent = () => {
  const { assetHistory } = useContext(AssetContext);

  const assetHistoryData = assetHistory?.data;

  const EventName = (data: IAssetLog) => {
    if (data.eventType === 'Comment') return 'added a comment:';
    if (data.eventName === 'Updated Status comment')
      return 'Updated Status with comment:';
    return data.eventName;
  };

  const TextDialog = (data: IAssetLog) => {
    if (data.eventType === 'Comment') return true;
    if (data.eventName === 'Updated Status comment') return true;
    if (data.eventName === 'Updated Description field') return true;
    return false;
  };

  const { isDesktop, isMobile } = useSelector(checkDevice());

  return (
    <Column>
      <EndOfHistory>End of History</EndOfHistory>
      {assetHistoryData
        ?.sort((a, b) => {
          if (!a.createdAt) return 1;
          if (!b.createdAt) return -1;
          return (
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          );
        })
        .map(data => {
          if (
            data.eventName === 'Updated Status comment' &&
            data.newValue === ''
          )
            return <div />;
          if (
            data.eventName === 'Updated Description field' &&
            data.newValue === ''
          )
            return <div />;
          return (
            <ContentGroup>
              <Content key={data._id}>
                {isMobile && (
                  <DateContent>
                    {data.createdAt && format(new Date(data.createdAt), 'PP')} -{' '}
                    {data.createdAt && format(new Date(data.createdAt), 'p')}
                  </DateContent>
                )}
                <ValueRow>
                  <TriggeredByGroup>
                    <TriggeredByContent>
                      <TriggeredByPicture
                        src={
                          data.triggeredByAvatar
                            ? data.triggeredByAvatar
                            : UserPlaceholder
                        }
                        alt=""
                      />
                      <TriggeredByText>{data.triggeredBy}</TriggeredByText>
                    </TriggeredByContent>

                    <EventNameContent>{EventName(data)}</EventNameContent>
                  </TriggeredByGroup>
                  {!TextDialog(data) && <AssetHistoryValues data={data} />}
                </ValueRow>

                {isDesktop && (
                  <DateContent>
                    {data.createdAt && format(new Date(data.createdAt), 'PP')} -{' '}
                    {data.createdAt && format(new Date(data.createdAt), 'p')}
                  </DateContent>
                )}
              </Content>

              {TextDialog(data) && <AssetHistoryValues data={data} />}
            </ContentGroup>
          );
        })}
    </Column>
  );
};

export { AssetHistoryContent };
